import axios from "axios";
import React from "react";
import toast from "react-hot-toast";
import { IoCloseCircleSharp } from "react-icons/io5";
import { server } from "../server";

const CategoryForm = ({
  handleSubmit,
  value,
  setValue,
  currentImages,
  brandId,
  setImageUrl,
  imageUrl,
}) => {
  const deleteImage = async (image) => {
    const toastId = toast.loading("Deleting ...");
    await axios
      .delete(`${server}/api/brand/delete-brand-image/${brandId}`, {
        params: {
          image,
        },
      })
      .then((res) => {
        // window.location.reload();
        toast.dismiss(toastId);
        toast.success("Image deleted");
      })
      .catch((error) => {
        console.log(error);
        toast.error("Error in deleting Image");
        toast.dismiss(toastId);
      });
  };
  const MAX_FILE_SIZE = 200 * 1024;

  const handleRemoveImage = (index) => {
    const updatedImages = [...imageUrl];
    updatedImages.splice(index, 1);
    setImageUrl(updatedImages);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="px-5">
          <label for="exampleInputEmail1" className="form-label">
            Current Image
          </label>

          <div
            className="mb-3"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
              justifyContent: "center",
              overflow: "hidden",
              maxWidth: "100%",
            }}
          >
            {currentImages.map((image, index) => (
              <div
                key={index}
                className="text-center"
                style={{ position: "relative" }}
              >
                <img
                  src={image.url}
                  alt={`car_image_${index}`}
                  className="img img-fluid"
                  style={{
                    maxWidth: "80px",
                    height: "auto",
                    borderRadius: "5px",
                    objectFit: "cover",
                  }}
                />
                <button
                  type="button"
                  className="remove-image-btn"
                  onClick={() => deleteImage(image.public_id)}
                  style={{
                    border: "none",
                    backgroundColor: "none",
                    background: "none",
                    position: "absolute",
                    top: "-2px",
                    right: "10px",
                    color: "red",
                  }}
                >
                  <IoCloseCircleSharp size={20} style={{ color: "green" }} />
                </button>
              </div>
            ))}
          </div>

          <div className="image-upload mb-3">
            <label className="upload-label col-md-12">
              Change this Image
              <input
                type="file"
                name="productPictures"
                accept="image/*"
                multiple
                onChange={(e) => {
                  let files = Array.from(e.target.files);
                  files.forEach((file) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                      const image = new Image();
                      image.src = reader.result;
                      image.onload = () => {
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");

                        const MAX_WIDTH = 800; // Max width for the image
                        const MAX_HEIGHT = 600; // Max height for the image

                        let width = image.width;
                        let height = image.height;

                        // Resize the image if it exceeds the max width or height
                        if (width > MAX_WIDTH || height > MAX_HEIGHT) {
                          const aspectRatio = width / height;
                          if (width > height) {
                            width = MAX_WIDTH;
                            height = width / aspectRatio;
                          } else {
                            height = MAX_HEIGHT;
                            width = height * aspectRatio;
                          }
                        }

                        canvas.width = width;
                        canvas.height = height;

                        ctx.drawImage(image, 0, 0, width, height);

                        canvas.toBlob(
                          (blob) => {
                            if (blob.size <= MAX_FILE_SIZE) {
                              setImageUrl((old) => [
                                ...old,
                                canvas.toDataURL(),
                              ]);
                            } else {
                              console.log("Image size exceeds 200KB");
                            }
                          },
                          "image/jpeg",
                          0.6
                        ); // 0.6 is the image quality (adjust as needed)
                      };
                    };
                    reader.readAsDataURL(file);
                  });
                }}
                hidden
              />
            </label>
          </div>
          {imageUrl.map((image, index) => (
            <div
              key={index}
              className="text-center"
              style={{ position: "relative", width: "100px" }}
            >
              <img
                src={image}
                alt={`car_image_${index}`}
                className="img img-fluid"
                style={{
                  maxWidth: "80px",
                  height: "auto",
                  borderRadius: "5px",
                  objectFit: "cover",
                }}
              />
              <button
                type="button"
                className="remove-image-btn"
                onClick={() => handleRemoveImage(index)}
                style={{
                  border: "none",
                  backgroundColor: "none",
                  background: "none",
                  position: "absolute",
                  top: "-2px",
                  right: "10px",
                  color: "red",
                }}
              >
                <IoCloseCircleSharp size={20} style={{ color: "green" }} />
              </button>
            </div>
          ))}

          <label for="exampleInputEmail1" className="form-label">
            Brand Name
          </label>
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="form-control"
          />
          <button type="submit" className="btn btn-success my-3">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default CategoryForm;
